module.exports = __webpack_public_path__ + "static/fond-bottom-a4bc7b0479433232dc954d9c2d436d1a.png";